import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cardGlow/cardGlow"
 * Contains 6 texture(s)
 */
export class CardglowAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cardGlow/cardGlow';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'glowTopCut.png',
        'glowTop.png',
        'glowMiddleCut.png',
        'glowMiddle.png',
        'glowBottomCut.png',
        'glowBottom.png'
    ] as const;
}
